var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-donut-chart"},[_c('apexchart',{attrs:{"type":"donut","height":160,"options":_vm.chartOptions,"series":_vm.chartSeries}}),_vm._t("legend")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }